import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskQueueUnset_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

import logError from 'src/utils/logError';

interface Fragments {
  activityLog: ActivityLogTaskQueueUnset_ActivityLogFragment;
}

const ActivityLogTaskQueueUnset: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;
  let name = 'Unknown';

  // eslint-disable-next-line no-underscore-dangle
  if (details?.__typename === 'ActivityLogTaskQueueDetails') {
    name = details.taskQueue?.name || name;
  } else {
    logError('ActivityLogTaskQueueDetails: details is not ActivityLogTaskQueueDetails');
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.removedTaskFromQueue"
      actionLabelValues={{ queueName: name }}
    />
  );
};

ActivityLogTaskQueueUnset.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskQueueUnset_activityLog on ActivityLog {
      id
      details {
        __typename
        ... on ActivityLogTaskQueueDetails {
          taskQueue {
            id
            name
          }
        }
      }

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskQueueUnset;
